<template>
    <ValidationObserver ref="validator">
        <div style="height:34px; margin-top:-46px;">
            <span class="inlineBLock tag__span__radio">
                <input
                    class="tag__span__radio__input"
                    type="radio" name="priceType"
                    v-model="priceIsRange"
                    :value="false"
                >
            </span>
            <span class="inlineBLock pinched">
                <label>Цена</label>
                <vee-input
                    name="Цена"
                    class="inlineBLock input__price pinched"
                    :rules="{max: 7, required: price.discount !== null && price.discount !== '', min_value: 0}"
                    type="number"
                    customStyle="height:34px!important;"
                    :disabled="priceIsRange"
                    v-model="price.amount"
                    @changed="setPrice"
                />
            </span>
            <span class="inlineBLock pinched">
                <label>Цена со скидкой</label>
                <vee-input
                    name="Цена со скидкой"
                    class="inlineBLock input__price pinched"
                    :rules="{max: 7, max_value: price.amount ? price.amount - 1 : false, min_value: 0}"
                    type="number"
                    customStyle="height:34px!important;"
                    :disabled="priceIsRange"
                    v-model="price.discount"
                    @changed="setPrice"
                />
            </span>
            <span class="inlineBLock tag__span__radio">
                <input
                    class="tag__span__radio__input"
                    type="radio"
                    name="priceType"
                    v-model="priceIsRange"
                    :value="true"
                >
            </span>
            <span class="inlineBLock pinched">
                <label>Цена от</label>
                <vee-input
                    name="Цена от"
                    class="inlineBLock input__price pinched"
                    :rules="{max: 7, max_value: price.to ? price.to - 1 : false, min_value: 0}"
                    type="number"
                    customStyle="height:34px!important;"
                    :disabled="!priceIsRange"
                    v-model="price.from"
                    @changed="setPrice"
                />
            </span>
            <span class="inlineBLock pinched">
                <label>Цена до</label>
                <vee-input
                    name="Цена до"
                    class="inlineBLock input__price pinched"
                    :rules="{max: 7, min_value: price.from !== null && price.from !== '' ? Number(price.from) + 1 : 0}"
                    type="number"
                    customStyle="height:34px!important;"
                    :disabled="!priceIsRange"
                    v-model="price.to"
                    @changed="setPrice"
                />
            </span>
        </div>
    </ValidationObserver>
</template>

<script>
    export default {
        data: () => ({
            priceIsRange: false,
            price: {
                amount: null,
                discount: null,
                from: null,
                to: null,
            }
        }),
        mounted() {
            this.setPrice()
        },
        methods: {
            setPrice() {
                this.$emit('setOptional', this.price)
            }
        },
        watch: {
            priceIsRange(n) {
                if (n === true) {
                    this.price.amount = null;
                    this.price.discount = null;
                } else {
                    this.price.to = null;
                    this.price.from = null;
                }

            }
        }
    }
</script>

<style scoped>
    .pinched {
        width:67px!important;
        height:34px!important;
    }
</style>
